var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCryptifyMeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 179,
    height: 179,
    rx: 9.5,
    fill: "#252525",
    stroke: "#C6C6C6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M111.697 99.2466H101.153V110.115C95.8495 112.52 91.7662 114.734 91.8504 120.053C91.9332 125.283 96.2144 127.463 101.153 129.679V140.548H137.746C140.733 140.257 141.887 139.414 142.397 135.89V99.2466H132.164C128.824 104.329 127.331 108.563 121.93 108.563C116.529 108.563 114.37 104.967 111.697 99.2466Z",
    stroke: "white",
    strokeWidth: 5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8143 135.001V99.5559H70.2938C72.391 93.7987 74.7947 90.0835 80.1568 90.0011C85.606 89.9173 86.9446 94.7237 90.328 99.5559H100.807V110.035C95.4305 112.377 91.7998 114.403 91.5609 119.59C91.3098 125.042 96.2444 127.248 100.807 130.07V140.549H64.1294C63.0109 140.723 59.4993 138.57 59.8143 135.001Z",
    stroke: "white",
    strokeWidth: 5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9863 79.2122V42.8423C37.1452 40.0817 38.0481 39.1252 41.6096 38.8354H77.9795V49.6231C83.5531 51.6351 86.856 54.5909 86.6096 59.7944C86.376 64.7283 83.1299 66.6434 77.9795 69.0409V79.2122H66.5754C63.8448 73.3802 62.2676 70.6627 57.3288 70.582C52.3013 70.4999 50.4766 73.034 47.774 79.2122H36.9863Z",
    stroke: "white",
    strokeWidth: 5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M137.157 59.7986H101.096V70.278C106.312 73.1963 111.52 74.8375 111.267 80.4493C111.017 85.9923 105.997 87.9147 100.479 89.6958V100.175H111.267C114.316 105.133 116.589 109.356 122.055 109.114C127.248 108.883 129.478 105.055 131.918 100.175H142.089V64.1136C142.023 63.2508 140.832 59.6648 137.157 59.7986Z",
    stroke: "white",
    strokeWidth: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCryptifyMeLogo);
export default __webpack_public_path__ + "static/media/CryptifyMELogo.ad4569fced43c21d931d6fafb684e30a.svg";
export { ForwardRef as ReactComponent };